var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9167 24.9598C33.9167 30.5714 30.5713 33.9168 24.9596 33.9168H23.125C22.2771 33.9168 21.5833 33.2231 21.5833 32.3752V23.4798C21.5833 23.0635 21.9225 22.7089 22.3387 22.7089L25.0521 22.6627C25.2679 22.6473 25.4529 22.4931 25.4992 22.2773L26.0388 19.3327C26.085 19.0552 25.8692 18.7931 25.5763 18.7931L22.2925 18.8393C21.8608 18.8393 21.5217 18.5002 21.5063 18.0839L21.4446 14.3068C21.4446 14.0602 21.645 13.8443 21.9071 13.8443L25.6071 13.7827C25.8692 13.7827 26.0696 13.5823 26.0696 13.3202L26.0079 9.62015C26.0079 9.35806 25.8075 9.15767 25.5454 9.15767L21.3829 9.21935C18.8238 9.2656 16.7888 11.3622 16.835 13.9214L16.9121 18.161C16.9275 18.5927 16.5884 18.9318 16.1567 18.9473L14.3067 18.9781C14.0446 18.9781 13.8442 19.1785 13.8442 19.4406L13.8904 22.3698C13.8904 22.6318 14.0908 22.8322 14.3529 22.8322L16.2029 22.8014C16.6346 22.8014 16.9737 23.1406 16.9892 23.5568L17.1279 32.3443C17.1433 33.2077 16.4496 33.9168 15.5862 33.9168H12.0404C6.42876 33.9168 3.08334 30.5714 3.08334 24.9443V12.0406C3.08334 6.42891 6.42876 3.0835 12.0404 3.0835H24.9596C30.5713 3.0835 33.9167 6.42891 33.9167 12.0406V24.9598V24.9598Z",
    fill: "#E3E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.2b036209267db71cd97b618c6524f738.svg";
export { ForwardRef as ReactComponent };